// WalletContext.js
import { createContext } from 'react'

const WalletContext = createContext({
  address: null,
  balance: null,
  setAddress: () => {},
  setBalance: () => {},
})

export default WalletContext
